import { render, staticRenderFns } from "./learned.vue?vue&type=template&id=66e133b8&scoped=true&"
import script from "./learned.vue?vue&type=script&lang=js&"
export * from "./learned.vue?vue&type=script&lang=js&"
import style0 from "./learned.vue?vue&type=style&index=0&id=66e133b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e133b8",
  null
  
)

export default component.exports